import { ReactNode } from 'react';

import { THEME_CLASSNAMES } from '@boss/constants/corporate-jobs';
import { SimpleImage } from '@boss/types/b2b-b2c';
import { ContentPageFields, ThemeColor } from '@boss/types/corporate-jobs';

type Cta = {
  href: string;
  id: string;
  label: string;
};

const getBackGroundColorClassName = (themeColor: ThemeColor): string => {
  if (themeColor) {
    return THEME_CLASSNAMES.background[themeColor];
  } else {
    return 'bg-brand';
  }
};

const getContentPageCardProps = (
  entry: ContentPageFields,
  locale: string,
  themeColor: ThemeColor,
): {
  cta?: Cta;
  description?: ReactNode;
  image?: SimpleImage;
  title?: string;
  backGroundColorClassName?: string;
} => {
  return {
    title: entry.pageTitle,
    description: entry.metaDescription,
    image: entry.mainImage
      ? {
          imageUrl: entry.mainImage?.image.file?.url,
          imageAlt: entry.mainImage?.altText ?? 'content-tile-image',
          id: entry.mainImage?.id,
        }
      : undefined,
    backGroundColorClassName: entry.mainImage ? undefined : getBackGroundColorClassName(themeColor),
  };
};

export default getContentPageCardProps;
